import { z } from 'zod';

/**
 * Wire schemas for photo API responses
 * These match the backend response format (snake_case)
 */

/**
 * Metadata shared by every photo object the gateway returns (check-in photos,
 * note photos, feed photos, business photos). Dimensions are of the stored
 * WebP. All three are nullable (rows written before the dimension backfill)
 * and optional (older API responses that predate the fields).
 */
export const photoMetaWireFields = {
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional(),
  alt_text: z.string().nullable().optional(),
};

export const photoMetaWireSchema = z.object(photoMetaWireFields);

export type PhotoMetaWire = z.infer<typeof photoMetaWireSchema>;

/**
 * Check-in photo wire schema (matches backend response format)
 * Based on CheckInPhotoReadSchema from Gateway
 */
export const photoWireSchema = z.object({
  id: z.string(),
  check_in_id: z.string(),
  r2_key: z.string(),
  image_url: z.string().url(),
  created_at: z.string(), // D1 DATETIME (ISO format)
  // Selection index (0..2) sent at upload; null for rows before migration 027,
  // absent from older API responses.
  position: z.number().int().nullable().optional(),
  ...photoMetaWireFields,
});

export type PhotoWire = z.infer<typeof photoWireSchema>;

/**
 * Photo upload response schema
 */
export const photoUploadResponseSchema = photoWireSchema;

export type PhotoUploadResponse = z.infer<typeof photoUploadResponseSchema>;
